import { ArticleCard, type ArticleCardHeadingLevel } from './article-card'
import type { ArticlePreview } from '@/lib/article-previews'

/** Data adapter only: all article-list presentation stays in ArticleCard. */
export function ArticlePreviewCard({ article, eager = false, headingLevel }: {
  article: ArticlePreview
  eager?: boolean
  /** FRIDGE-1504 L1504-9: passed to ArticleCard; default h3. */
  headingLevel?: ArticleCardHeadingLevel
}) {
  return <ArticleCard
    href={`/blogs/news/${article.slug}`}
    title={article.title}
    imageUrl={article.image || undefined}
    author={article.authorName || undefined}
    authorImageUrl={article.authorImageUrl}
    date={article.publishedAt || undefined}
    excerpt={article.excerpt}
    badge="News"
    className="h-full"
    eager={eager}
    headingLevel={headingLevel}
  />
}
